import { Component, Element, h, Host, Method, Prop, State } from '@stencil/core'

/**
 * Wizard Panel (Painel de etapa do Wizard)
 * Representa uma etapa individual dentro do br-wizard.
 *
 * @slot default - Slot para o conteúdo da etapa (formulários, campos ou informações da fase atual).
 */
@Component({
  tag: 'br-wizard-panel',
  styleUrl: 'wizard-panel.scss',
  shadow: true,
})
export class WizardPanel {
  @Element() el: HTMLBrWizardPanelElement

  /**
   * Label do painel (aparece no indicador de progresso)
   */
  @Prop({ reflect: true }) label!: string

  /**
   * Estados internos controlados pelo wizard pai via métodos públicos
   */
  @State() private active: boolean = false
  @State() private index: number = 1

  /**
   * Define se o painel está ativo
   * @internal Método interno chamado apenas pelo wizard pai
   */
  @Method()
  async setActive(value: boolean) {
    this.active = value
  }

  /**
   * Define o índice do painel
   * @internal Método interno chamado apenas pelo wizard pai
   */
  @Method()
  async setIndex(value: number) {
    this.index = value
  }

  /**
   * Retorna se o painel está ativo
   * @internal Método interno para o wizard pai consultar o estado
   */
  @Method()
  async isActive(): Promise<boolean> {
    return this.active
  }

  render() {
    const hostAttrs = {
      ...(this.active && { active: 'true' }),
    }

    return (
      <Host {...hostAttrs}>
        <div class="wizard-panel" role="tabpanel" id={`wizard-panel-${this.index}`}>
          <div class="wizard-panel-content">
            <slot></slot>
          </div>
        </div>
      </Host>
    )
  }
}
